import React, { useState, useEffect, useContext, Dispatch, SetStateAction } from 'react';
import { CensusData } from "../../../interfaces/devices/census_interface";
import { GlobalContext } from "../../../hooks/globalContext";
import apiCall from '../../../utility/api';
import { fetchdartTemplateList, fetchJsonSchema } from '../../automation/automation_common_func';

type CensusProps = {
    operationType?: any;
    setOperationType?: any;
    setOverlayType?: any;
    overlayOpen?: boolean;
    data?: any;
    func?: Dispatch<SetStateAction<CensusData[] | null>> | any;
    searchVal?: string | any;
    pageNo?: string | number | any;
    setTotalPages?: Dispatch<SetStateAction<number>> | any;
    setTotalRecords?: Dispatch<SetStateAction<number>> | any;
    isFilter?: boolean;
    setIsFilter?: Dispatch<SetStateAction<any>>;
    isRefresh?: boolean;
    setIsRefresh?: Dispatch<SetStateAction<boolean>> | any;
    setRefreshToast?: Dispatch<SetStateAction<boolean>> | any;
    setMachineStatus?: any;
    filterArray?: string[];
    setDevicesOfTenant?: Dispatch<SetStateAction<any>> | any;
    isChecked?: any;
    setExportDetails?: any;
    isExpungeMachineData?: boolean | any;
    setIsExpungeMachineData?: Dispatch<SetStateAction<boolean>> | any;
    refreshToast?: boolean;
    devicesOfTenant?: any;
    expungeType?: string | null;
    setExpungeType?: Dispatch<SetStateAction<string | null>> | any;
    setToastMessage?: Dispatch<SetStateAction<string>> | any;
    setErrorToast?: Dispatch<SetStateAction<boolean>> | any;
    setIsToast?: Dispatch<SetStateAction<boolean>> | any;
    setExportBtnClicked?: Dispatch<SetStateAction<boolean>> | any;
    exportBtnClicked?: boolean;
    pageName?: string;
    selectedValue?: number;
    setDartTemplatesList?: any;
    dropdownData?: null;
    saveBtnClicked?: any;
    setSaveBtnClicked?: any;
    setIsDisabled?: any;
    setJsonData?: any;
    setUiData?: any;
    dartNo?: any;
    overlayType?: any;
    dataList?: any;
    formData1?: any;
    setFormData1?: any;
    formData2?: any;
    setFormData2?: any;
    setOverlayOpen?: any;
}

export const Census_func = (props: CensusProps) => {
    const dartNo = props.dartNo;
    const contextValue: any = useContext(GlobalContext);
    const tenantName: string = contextValue.tenantName;
    console.log("contextValue",props.overlayType)
    var values = contextValue.selectedRowIdInSubTable.map((val: string) => val.split("-"));
    var hostname: string[] = values.map((val: any) => val?.slice(1).join("-"));

    const getCensusList = async (whereCondition: object, limit: number, offset: number) => {
        try {
            const { status, data } = await apiCall('/census/getCensus', { ...whereCondition, limit, offset });

            if (status === 'success') {
                if (props.isRefresh) {
                    props.setRefreshToast(true);
                    props.setIsRefresh(false);
                }
                props.func(data);

                getStatusOfdevicesList(contextValue.tenantName, "Sites", "yes");
            }
        } catch (error) {
            console.log("getCensusList error=", error);

            props.setErrorToast(true);
            props.setToastMessage("Unale to fetch the census list");
        }
    };

    const getCensusListsCnt = async (whereCondition: object) => {
        try {
            const { status, data } = await apiCall('/census/getCensusCount', whereCondition);

            if (status === 'success' && data.totalRecords > 0) {
                props?.setTotalRecords(data.totalRecords);
                props?.setTotalPages(data.totalPages);
            }
        } catch (error) {
            console.log("getCensusListsCnt error=", error);

            props?.setTotalRecords(0);
            props?.setTotalPages(1);
        }
    }

    const getExportData = async (condition: object) => {
        try {
            const { status, data } = await apiCall(`/census/getCensus`, condition);

            if (status === 'success') {
                props.exportBtnClicked && props.setExportDetails !== undefined && props.setExportDetails(data);

                props?.setDevicesOfTenant(data);
            }
        } catch (error) {
            console.log("getExportData error=", error);
        }

        props.setExportBtnClicked(false);
    }

    const getStatusOfdevicesList = async (name: string, type: string, deviceStatus: string) => {
        try {
            const condition = { tenant: tenantName }
            let { status, data } = await apiCall('/census/getDeviceStatus', condition);

            console.log("data=", data);
            if (status === 'success' && data) {
                var statusObj: any = {};
                data?.map((val: any) => {
                    statusObj[`${val.host}`] = [val.status.isOnline === true ? 'online' : 'offline', `${val.os}`];
                });

                props?.setMachineStatus(statusObj);
            }
        } catch (error) {
            console.log("getStatusOfdevicesList error=", error);
        }
    }

    const expungeDeviceData = async () => {
        try {
            if (hostname.length > 0) {
                let data = await apiCall('/census/expunge', {
                    selectedOptions: props.isChecked,
                    tenant: tenantName,
                    hosts: hostname,
                    type: props.expungeType
                });

                props.setIsExpungeMachineData(false);
                props.setExpungeType(null);
                if (data.status === "success") {
                    props.setIsToast(true);
                    props.setToastMessage("Expunged Successfully");

                    return true;
                } else {
                    props.setErrorToast(true);
                    props.setToastMessage("Failed to expunge the device data");

                    return false;
                }
            }
        } catch (error) {
            console.log("expungeDeviceData error=", error);
            props.setIsExpungeMachineData(false);
            props.setExpungeType(null);
            props.setErrorToast(true);
            props.setToastMessage("Failed to expunge the device data");

            return false;
        }
    }

    const getJsonSchema = async (dartid: number) => {
        props.setIsDisabled(true);
        try {
            const { data, status } = await fetchJsonSchema(dartid);

            if (status === 'success' && data.length > 0) {
                const uiSchema = JSON.parse(data[0]?.uiSchema);
                const jsonSchemaData = JSON.parse(data[0]?.jsonSchema);

                uiSchema["ui:submitButtonOptions"] = { "norender": true };

                data[0]?.jsonSchema != undefined && 
                props.setJsonData((prev:any)=>({
                    ...prev,
                    [dartid === 61 ? 'schema1' : 'schema2']: {
                        ...prev[dartid === 61 ? 'schema1' : 'schema2'],
                        ...jsonSchemaData, 
                      }}))
                      data[0]?.uiSchema != undefined &&
                       props.setUiData((prev:any)=>({
                        ...prev,
                        [dartid === 61 ? 'schema1' : 'schema2']: {
                            ...prev[dartid === 61 ? 'schema1' : 'schema2'], 
                            ...uiSchema, 
                          }}))

                setTimeout(() => {
                    props.setIsDisabled(false);
                }, 500)
            } else {
                props.setJsonData({});
                props.setUiData({});
            }
        } catch (error) {
            console.log("getJsonSchema error=", error);
            props.setJsonData({});
            props.setUiData({});
        }
    };

    const getClientConfigData = async (conditions: any) => {
        try {
            let {data, status} = await apiCall('/automation/getList', conditions);

            if(status === 'success' && data.length > 0) {
                if(data[0]?.dartid === 61){
                    props.setFormData1({jsonData: JSON.parse(data[0]?.jsonValue), id: data[0]?.id} );
                    props.setOperationType((prev) => ({...prev, "dart61": 'update'}));
                }

                if(data[0]?.dartid === 253){
                    props.setFormData2({jsonData: JSON.parse(data[0]?.jsonValue), id: data[0]?.id});
                    props.setOperationType((prev) => ({...prev, "dart253": 'update'}));
                }
            } else{
                conditions.dartid === 61 && props.setFormData1({});
                conditions.dartid === 253 && props.setFormData2({});
            }
        } catch (error) {
            console.log("getClientConfigData error=", error);  
            conditions.dartid === 61 && props.setFormData1({});
            conditions.dartid === 253 && props.setFormData2({});
        }
    }

    const addClientConfig = async (conditions: object) => {
        console.log("addClientConfig conditions=", conditions);
        try {
            let {data, status} = await apiCall('/census/addClientConfig', conditions);

            if(status === 'success') {
                props.setIsToast(true);
                props.setToastMessage("Client Config added successfully");
            }else{
                props.setErrorToast(true);
                props.setToastMessage("Failed to add client config");
            }
        } catch (error) {
            console.log("addClientConfig error=", error);

            props.setOperationType({dart61: 'add', dart253: 'add'});
            props.setErrorToast(true);
            props.setToastMessage("Failed to add client config");
        }

        props.setFormData1({});
        props.setFormData2({});
        props.setSaveBtnClicked(false);
        props.setOperationType({dart61: 'add', dart253: 'add'});

        setTimeout(() => {
            props.setOverlayOpen(false);
            props.setOverlayType("default");
        }, 1000);
    };

    const updateClientConfig = async (conditions: object) => {
        console.log("updateClientConfig conditions=", conditions);
        try {
            let {status} = await apiCall('/census/updateClientConfig', conditions);

            if(status === 'success') {
                props.setIsToast(true);
                props.setToastMessage("Client Config updated successfully");
            }else{
                props.setErrorToast(true);
                props.setToastMessage("Failed to update client config");
            }
        } catch (error) {
            console.log("addClientConfig error=", error);
            
            props.setOperationType({dart61: 'add', dart253: 'add'});
            props.setErrorToast(true);
            props.setToastMessage("Failed to update client config");
        }

        props.setFormData1({});
        props.setFormData2({});
        props.setSaveBtnClicked(false);
        props.setOperationType({dart61: 'add', dart253: 'add'});

        setTimeout(() => {
            props.setOverlayOpen(false);
            props.setOverlayType("default");
        }, 1000);
    };

    useEffect(() => {  
        if (props.overlayType && props.overlayType === "config" && props?.dataList?.length > 0 ) {
            props.dataList.map(async (data: any) => {
                await getJsonSchema(data);
                await getClientConfigData({ automationName: data === 253 ? `${tenantName}_customerinfo` : `${tenantName}_asset`, dartid: data, types: 'client_config' });
            });
        }

        if (props.pageName !== undefined && props.pageName === 'device_classification') {

            const tempName = localStorage.getItem('classificationName');
            const classificationName = (tempName != undefined && tempName.length > 0) ? tempName : contextValue.selectedRowDetails.name;

            if (props?.searchVal?.length > 0 && props.searchVal !== '') {
                getCensusList({ tenant: tenantName, classification: classificationName, search: props.searchVal, type: 'search' }, 50, parseInt(props?.pageNo));
                getCensusListsCnt({ tenant: tenantName, classification: classificationName, search: props.searchVal, type: 'search' });
            } else if (props.isFilter == true) {
                getCensusList({ filter: props.filterArray, classification: classificationName, tenant: tenantName, type: 'filter' }, 50, props.pageNo);
                getCensusListsCnt({ filter: props.filterArray, classification: classificationName, tenant: tenantName, type: 'filter' });
            } else if (props.exportBtnClicked) {
                getExportData({ tenant: tenantName, classification: classificationName, function: 'export' });
            } else {
                getCensusList({ tenant: tenantName, classification: classificationName }, 50, parseInt(props.pageNo));
                getCensusListsCnt({ tenant: tenantName, classification: classificationName });

                // getAttachedDevices({tenant: tenantName, classification: classificationName, function: 'export'});
            }
        } else if (props?.searchVal?.length > 0 && props.searchVal !== '') {
            getCensusList({ tenant: tenantName, search: props.searchVal, type: 'search' }, 50, parseInt(props?.pageNo));
            getCensusListsCnt({ tenant: tenantName, search: props.searchVal, type: 'search' });
        } else if (props.isExpungeMachineData) {
            expungeDeviceData();
        } else if (props.isFilter === true) {
            console.log("filterArray=", props.filterArray);

            getCensusList({ filter: props.filterArray, tenant: tenantName, type: 'filter' }, 50, props.pageNo);
            !props.filterArray.some(item => item.startsWith(`Device Status :`)) && getCensusListsCnt({ filter: props.filterArray, tenant: tenantName, type: 'filter' });
        } else if (props.exportBtnClicked || (props.devicesOfTenant?.length === 0 && props.overlayOpen && props.selectedValue === 2)) {
            getExportData({ tenant: tenantName, function: 'export' });
        }
        
        if (props.overlayType === "config" && props.saveBtnClicked && props.operationType.dart61 === "add" && Object.keys(props.formData1?.jsonData).length > 0) {
            addClientConfig({ tenant: tenantName, dartid: 61, dart61FormData: {...props.formData1?.jsonData} });
        } else if (props.overlayType === "config" && props.saveBtnClicked && props.operationType.dart61 === "update" && Object.keys(props.formData1?.jsonData).length > 0) {
            updateClientConfig({ tenant: tenantName, dart61Id: props.formData1.id, dart253Id: props.formData2.id, dart61FormData: {...props.formData1?.jsonData} });
        } 
        
        if (props.overlayType === "config" && props.saveBtnClicked && props.operationType.dart253 === "add" && Object.keys(props.formData2?.jsonData).length > 0) {
            addClientConfig({ tenant: tenantName, dartid: 253, dart253FormData: {...props.formData2?.jsonData} });
        } else if (props.overlayType === "config" && props.saveBtnClicked && props.operationType.dart253 === "update" && Object.keys(props.formData2?.jsonData).length > 0) {
            updateClientConfig({ tenant: tenantName, dart61Id: props.formData1.id, dart253Id: props.formData2.id, dart253FormData: {...props.formData2?.jsonData} });
        }

        console.log("operationType=", props.operationType);
        
        
        if (props.overlayType === "default" && dartNo === 0) {
            getCensusList({ tenant: tenantName }, 50, parseInt(props.pageNo));
            getCensusListsCnt({ tenant: tenantName });
        }
    }, [props.searchVal, props.pageNo, props.isFilter, props.isRefresh, props.isExpungeMachineData, props.filterArray, props.exportBtnClicked, props.selectedValue, props.overlayType, props.saveBtnClicked]);

    return (<></>)
}